import { showCustomToast } from "./showCustomToast";

let lastViolation: string | null = null;
let violationTimeout: NodeJS.Timeout | null;

export const differentiateToasts = (
  violationKey: string,
  cooldown = 10000
): void => {
  if (violationKey !== lastViolation) {
    showCustomToast(violationKey);
    lastViolation = violationKey;

    if (violationTimeout) clearTimeout(violationTimeout);

    violationTimeout = setTimeout(() => {
      lastViolation = null;
    }, cooldown);
  }
};
